import React from 'react';

interface IconPlusProps {
    iconClasses?: string;
}

const IconPlus: React.FC<IconPlusProps> = ({ iconClasses }) => {
    return (
        <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-plus ${iconClasses ?? ''}`}
        >
            <path
                d="M5.50065 11C4.95065 11 4.58398 10.6333 4.58398 10.0833V0.916667C4.58398 0.366667 4.95065 0 5.50065 0C6.05065 0 6.41732 0.366667 6.41732 0.916667V10.0833C6.41732 10.6333 6.05065 11 5.50065 11Z"
                fill="currentColor"
            />
            <path
                d="M10.0833 6.41667H0.916667C0.366667 6.41667 0 6.05 0 5.5C0 4.95 0.366667 4.58333 0.916667 4.58333H10.0833C10.6333 4.58333 11 4.95 11 5.5C11 6.05 10.6333 6.41667 10.0833 6.41667Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconPlus;
